<div class="my-applications-container">
    
    <div class="date-range-form-container mb-4">
        <!-- Using dynamic-search-form component without buttons -->
        <div class="date-fields-wrapper">
            <app-dynamic-search-form 
                [config]="dateRangeFields" 
                [buttonLabel]="false">
            </app-dynamic-search-form>
            
            <!-- Individual Error Messages positioned below each field -->
            <div class="date-errors-container">
                <!-- Start Date Error (Column 1) -->
                <div class="start-date-error-wrapper">
                    <div *ngIf="startDateError" class="text-danger mt-1 err-font">
                        {{ startDateError }}
                    </div>
                </div>
                
                <!-- End Date Error (Column 2) -->
                <div class="end-date-error-wrapper">
                    <div *ngIf="endDateError" class="text-danger mt-1 err-font">
                        {{ endDateError }}
                    </div>
                </div>
                
                <!-- Empty columns 3 and 4 to match the grid -->
                <div></div>
                <div></div>
            </div>
        </div>

        <!-- Custom Reset and Submit Buttons -->
        <div class="button-row d-flex mt-3 justify-content-end mb-3">
            <button type="button" 
                    class="btn btn-outline btn-width-100 btn-modal-action me-3 btn-radius" 
                    (click)="onDateRangeReset()"
                    [disabled]="!isResetEnabled()">
                Reset
            </button>
            <button type="button" 
                    class="btn btn-primary btn-width-100 btn-modal-action ml-0 btn-radius"
                    (click)="onDateRangeSubmit()"
                    [disabled]="disableSubmitButton">
                Submit
            </button>
        </div>
    </div>

    <!-- Payment Reconciliation Results Grid -->
    <div *ngIf="showDateRangeGrid" class="mt-3">
        
        <div class="d-flex justify-content-end align-items-center mb-3" *ngIf="transactionTableData && transactionTableData.length > 0">
            <!-- Action Buttons -->
            <div class="d-flex gap-2">
                <!-- Export Button -->
                <div class="queues-export-btn-group">
                    <button class="icon-btn" type="button" title="Export" (click)="downloadExcel()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <path
                                d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                                fill="currentColor" />
                        </svg>
                    </button>
                </div>

                <!-- Column Chooser Button -->
                <div class="queues-column-chooser-group">
                    <button class="icon-btn" type="button" title="Column Chooser" (click)="showColumnChooser = !showColumnChooser">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <path
                                d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                                fill="currentColor" />
                        </svg>
                    </button>
                    
                    <!-- Column Chooser Dialog -->
                    <div *ngIf="showColumnChooser" class="queues-column-chooser-dialog column-chooser-dialog">
                        <div class="queues-column-chooser-header column-chooser-header">
                            Column Chooser
                            <button class="column-chooser-close" (click)="closeColumnChooser()">&times;</button>
                        </div>
                        <div class="column-chooser-list">
                            <label *ngFor="let col of allColumns" class="column-chooser-checkbox"
                                   [class.disabled]="col.disabled || (getSelectedColumnsCount() === 1 && visibleColumns[col.key])">
                                <input type="checkbox" 
                                       [checked]="visibleColumns[col.key]" 
                                       [disabled]="col.disabled || (getSelectedColumnsCount() === 1 && visibleColumns[col.key])"
                                       (change)="onColumnClick(col)"
                                       [id]="'col_' + col.key">
                                <span>{{ col.caption }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="payment-table-wrapper" *ngIf="transactionTableData && transactionTableData.length > 0">
            <app-data-grid [config]="transactionGridConfig"></app-data-grid>
        </div>
        <div *ngIf="!transactionTableData || transactionTableData.length === 0" class="alert alert-info">
            No transaction records found for the selected date range.
        </div>
    </div>
</div>
